import { connect } from 'react-redux'
import * as action from '../../state/manage/action'
import * as selector from '../../state/manage/selector'
import ManageEmailTemplate from './ManageEmailTemplate'
import { selectHasRole } from '../../../security/state/auth/selector'
import { ROLE_EMAIL_ADMIN } from '../../../security/state/auth/const'


const mapStateToProps = (state, props) => {
    return {
        userSelection: selector.selectUserSelection(state),
        processList: selector.selectProcessList(state),
        templateList: selector.selectTemplateListForProcess(state),
        emailTemplate: selector.selectEmailTemplate(state),
        emailTemplateVariantList: selector.selectEmailTemplateVariantList(state),
        isEmailAdmin: selectHasRole(state, ROLE_EMAIL_ADMIN),
        processMacroList: selector.selectProcessMacroListForCurrentProcess(state),
    }
}

const mapDispatchToProps = {
    findEmailTemplateList: action.findEmailTemplateList,
    changeProcess: action.changeProcess,
    findEmailTemplateById: action.findEmailTemplateById,
    changeLocale: action.changeLocale,
    changeEmailTemplateVariant: action.changeEmailTemplateVariant,
    saveEmailTemplateVariant: action.saveEmailTemplateVariant,
    createEmailTemplateVariant: action.createEmailTemplateVariant,
    testEmailTemplateVariant: action.testEmailTemplateVariant,
    deleteEmailTemplateVariant: action.deleteEmailTemplateVariant,
    getProcessMacroList: action.getProcessMacroList,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageEmailTemplate)



// WEBPACK FOOTER //
// ./src/modules/email/component/manage/ManageEmailTemplateContainer.js